<template>
  <loading-page v-if="fetchingRestrictions" />
  <paper
    v-else
    class="container mt-2 top-fade-in"
  >
    <div
      class="position-relative"
      :class="{ filter: savingChanges }"
    >
      <restriction-type
        v-for="(type, index) in restrictions"
        :key="`${type.restrictionType}-${index}`"
        :type="type"
        @refreshRestrictions="fetchRestrictions"
      />

      <div class="px-2">
        <custom-alert
          :items-center="true"
          icon-name="Info"
        >
          Take caution when configuring restrictions, if you allow access to a
          specific IP, Country or Referrer that means that all other IPs,
          Countries, and Referrers won't be able to access your content.
        </custom-alert>
      </div>
      <template v-if="savingChanges">
        <div class="loading">
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
        </div>
      </template>
    </div>
  </paper>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import RestrictionType from './RestrictionType.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'Restrictions',
  components: {
    Paper,
    RestrictionType,
  },
  data() {
    return {}
  },
  computed: {
    distributionId() {
      return this.$route.params.id
    },
    fetchingRestrictions() {
      return this.$store.state.cdn.fetchingRestrictions
    },
    restrictions() {
      return this.$store.state.cdn.restrictions
    },
    savingChanges() {
      return (
        this.$store.state.cdn.creatingRestriction
        || this.$store.state.cdn.updatingRestriction
        || this.$store.state.cdn.deletingRestriction
      )
    },
  },
  created() {
    this.fetchRestrictions()
  },
  methods: {
    fetchRestrictions() {
      this.$store
        .dispatch('cdn/fetchRestrictions', this.distributionId)
        .catch(err => redirectError(err, this.$route.path))
    },
  },
}
</script>

<style>
.delete {
  margin: 0 24px 24px;
}
.delete .title {
  font-weight: 500;
}
.delete .subtitle {
  font-size: 12px;
}
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  top: 0;
}
.filter {
  filter: blur(1px);
}
</style>
